export default function() {
    if(document.querySelector('.tabs-image') !== null) {
        // const element = document.querySelector('.tabs-image');
        // const observer = new IntersectionObserver(entries => {
        //     element.classList.toggle('isInView', entries[0].isIntersecting);
        // });

        // observer.observe(element);
    }
}